export default __webpack_public_path__ + "static/media/Frostmaw Boots.b27cf62f.jpg";